import type { HTMLAttributes, ReactNode } from 'react';

// Chrome dell'header dell'app, colorato in base all'ambiente.
// Production = chrome neutro. Staging = chrome ambra completo (no badge).
// Development = chrome ambra + tag DEV (per disambiguare dallo stage).

export type InstanceEnv = 'production' | 'staging' | 'development';

export interface EnvChromeProps extends HTMLAttributes<HTMLElement> {
  env: InstanceEnv;
  children?: ReactNode;
}

export function EnvChrome({ env, children, className, ...rest }: EnvChromeProps) {
  return (
    <header className={`audiq-env-chrome relative ${className ?? ''}`} data-env={env} {...rest}>
      {children}
    </header>
  );
}
